const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/checklist-library/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/checklist-library/")({
  beforeLoad: args => requirePermission(Permissions.ChecklistLibrary.Manage, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type PublishedFilter = "all" | "published" | "unpublished";
type ActiveFilter = "active" | "inactive" | "all";

/** Sentinel for the industry filter's "all" item (Radix Select forbids ""). */

/**
 * System Checklist Library catalog: every versioned SystemChecklist with
 * its industry tags, publish state and current version. Publishing needs
 * `system:checklistlibrary:publish`; everything else here needs `manage`.
 */